<template lang="pug">
  .select-container.relative(v-on-clickaway='hideOptions')
    .amount.absolute.row.middle.center.white.text-small(v-if='selected.length') {{ selected.length }}
    button.select-button(type='button' @click='toggleOptions' :disabled='disabled')
      span.dark-gray.text-normal.blue.bold {{ placeholder }}
      simple-svg.direction.m-left-1.blue-icon(
        :filepath='dropdownIcon'
        :class='{ open: showOptions }'
        alt='show options'
        width='16px'
        height='16px'
      )
    .options-container.kimple-scroll.absolute(v-if='showOptions')
      .option.text-normal(
        v-for='option in options'
        :class='{disabled: option.disabled}'
        :key='option.onClick ? option[labelName] : option[keyName]'
      )
        checkbox.m-right-1(
          transparent
          :checked='isOptionSelected(option[keyName])'
          :updateCheck='() => selectOption(option, option.disabled)'
        )
        span.text-normal(v-html='option[labelName]')
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import dropdownIcon from '@/assets/ic_chevron-down.svg'
import Checkbox from '../Inputs/Checkbox'

export default {
  mixins: [clickaway],
  components: { Checkbox },
  props: {
    name: { type: String, required: true },
    options: { type: Array, required: true },
    keyName: { type: String, default: 'value' },
    labelName: { type: String, default: 'label' },
    placeholder: { type: String },
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean }
  },
  data() {
    return {
      dropdownIcon,
      showOptions: false,
      selected: []
    }
  },
  watch: {
    value() {
      this.selected = this.value
    }
  },
  mounted() {
    this.selected = this.value
  },
  methods: {
    isOptionSelected(value) {
      return Boolean(this.selected.find(op => op === value))
    },
    toggleOptions() {
      this.showOptions = !this.showOptions
    },
    hideOptions() {
      this.showOptions = false
    },
    selectOption(option, disabled) {
      if (disabled) return
      const isRemove = this.isOptionSelected(option.value)
      if (isRemove) {
        this.selected = this.selected.filter(op => op !== option.value)
      } else {
        this.selected = [...this.selected, option.value]
      }
      this.hideOptions()
      this.$emit('change', this.name, option.value, isRemove)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/variables/z-indexes';
@import 'src/scss/common/forms';

.select-container {
  position: relative;
  width: auto;
}

.amount{
  background-color: $sandy-brown;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  top: 0;
  right: 0;
  z-index: 1;
  border: 1px solid $white;
  transform: translate(5px, -10px);
}

.select-button {
  @extend .select-base;
  width: auto;
  align-items: center;
  display: flex;
  height: var(--input-height, 40px);
  justify-content: space-between;
  margin: 0;
  text-align: left;
  transition: opacity 0.5s ease;

  &:disabled{
    opacity: 0.6;
    cursor: not-allowed;
    transition: opacity 0.5s ease;
  }
}

.open {
  transform: rotate(180deg);
}

.options-container {
  background-color: $white;
  border: 1px solid $light-gray;
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  max-height: 240px;
  overflow-y: auto;
  width: 235px;
  z-index: $select-options;
  margin-top: 5px;
}

.option {
  align-items: center;
  color: $black;
  display: flex;
  min-height: var(--input-height, 40px);
  padding: 6px 8px;
  text-align: left;
  width: 100%;
  &.small{
    min-height: 35px;
  }
  &.disabled{
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:hover {
    background-color: $light-gray;
  }
}
</style>
